export default __webpack_public_path__ + "static/media/logo-tla-left-light.7db491fb.svg";